import {
  clearCommonCreateFieldFromValidationErrors,
  clearSpecificCreateFieldFromValidationErrors,
} from "../../common/utils/validationUtils";
import type { CreateResult } from "./createFormActions";
import type { CreateCandidate, CreateFormState } from "./createFormReducer";
import type { CreateMetaActions } from "./createMetaActions";
import type { CreateValidationErrors } from "./createReducer";

export interface CreateMetaState {
  extendedMode: boolean;
  initialized: boolean;
  result: CreateResult | null;
  submitting: boolean;
  validationErrors: CreateValidationErrors;
}

export const INITIAL_VALUE: CreateMetaState = {
  initialized: false,
  result: null,
  submitting: false,
  extendedMode: false,
  validationErrors: {
    common: {},
    specific: {},
  },
};

export const createMetaReducer = (
  state: CreateMetaState = INITIAL_VALUE,
  action: CreateMetaActions,
): CreateMetaState => {
  switch (action.type) {
    case "CREATE_FORM:INITIALIZE_CREATE_FORM":
      return {
        ...INITIAL_VALUE,
        initialized: true,
      };
    case "CREATE_FORM:REQUEST_CLEANUP_FORM":
      return INITIAL_VALUE;
    case "CREATE_FORM:SUBMIT_START":
      return {
        ...state,
        submitting: true,
      };
    case "CREATE_FORM:SET_CREATE_RESULT":
      return {
        ...state,
        result: action.payload.result,
        validationErrors: action.payload.validationErrors,
      };
    case "CREATE_FORM:UPDATE_COMMON_VALUES": {
      const validationErrors = {
        ...state.validationErrors,
        common: { ...state.validationErrors.common },
      };

      for (const value in action.payload.values) {
        clearCommonCreateFieldFromValidationErrors(
          value as keyof CreateFormState,
          validationErrors,
        );
      }

      return {
        ...state,
        validationErrors,
      };
    }
    case "CREATE_FORM:UPDATE_SPECIFIC_VALUES": {
      const specific = { ...state.validationErrors.specific };
      if (specific[action.payload.id]) {
        specific[action.payload.id] = { ...specific[action.payload.id] };
      }
      const validationErrors = {
        ...state.validationErrors,
        specific,
      };

      for (const value in action.payload.values) {
        clearSpecificCreateFieldFromValidationErrors(
          value as keyof CreateCandidate,
          validationErrors,
          action.payload.id,
        );
      }

      return {
        ...state,
        validationErrors,
      };
    }
    case "CREATE_FORM:SUBMIT_FINISHED":
      return {
        ...state,
        submitting: false,
      };
    case "CREATE_FORM:ENABLE_EXTENDED_MODE":
      return {
        ...state,
        extendedMode: true,
      };

    default:
      return state;
  }
};
